module.exports = __webpack_public_path__ + "static/closet-f4c0eb4d03a9a04c4e74d038fe53b036.jpg";